export class Timer {
    constructor(callback, delay) {
        this.callback = callback;
        this.delay = delay;
        this.remaining = delay;
        this.timerId = null;
        this.startTime = null;
    }

    // Pauses the timer
    pause() {
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
            // Record the time remaining
            this.remaining -= (Date.now() - this.startTime);
        }
    }

    // Resumes or starts the timer
    resume() {
        if (this.timerId) {
            // Timer is already running
            return;
        }

        // Set the start time
        this.startTime = Date.now();

        // Start a new timer with the remaining time
        this.timerId = setTimeout(() => {
            this.callback();
            // Reset for potential reuse
            this.remaining = this.delay;
        }, this.remaining);
    }

    // Stops and resets the timer completely
    stop() {
        clearTimeout(this.timerId);
        this.timerId = null;
        this.remaining = this.delay;
    }
}
